export function CreditCostPill({ amount, suffix, variant = 'default' }: { amount: number; suffix?: string; variant?: 'default' | 'white' }) {
  return (
    <span className={`inline-flex items-center gap-1 border rounded-full pl-2 pr-2.5 py-1 align-middle whitespace-nowrap ${variant === 'white' ? 'bg-surface-raised border-border/30' : 'border-line-strong'}`}>
      <img src="/one-coin.svg" alt="" className="h-5 w-5 inline" />
      <span className={`tracking-tight ${variant === 'white' ? 'text-foreground' : 'text-foreground'}`}>{amount}{suffix ? ` / ${suffix}` : ''}</span>
    </span>
  );
}
